import './styles/main.css';

import { createApp } from 'vue';
import { createPinia } from 'pinia';
import { VueQueryPlugin } from '@tanstack/vue-query';

import App from './App.vue';
import { router } from './router';
import { bootApp } from './boot';
import { queryClient } from './lib/query-client';

async function main(): Promise<void> {
  const app = createApp(App);
  const pinia = createPinia();
  app.use(pinia);

  // Boot sequence (§9.3) BEFORE the router/app mount — see boot/index.ts.
  await bootApp(pinia);

  app.use(router);
  // TanStack Query for Vue — required by every generated Orval Vue-Query
  // composable from @eskayscience/api-client once real endpoints exist. Pass the
  // shared `queryClient` singleton (../lib/query-client) rather than letting
  // the plugin construct its own — the P2-25 command poller's RELOAD/
  // DATA_CHANGED handlers invalidate against this same instance from outside
  // any component context.
  app.use(VueQueryPlugin, { queryClient });

  app.mount('#app');
}

void main();
